import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import useGetSettingFinancialStatement from '../../../financial/common/useGetSettingFinancialStatement'
import { selectPeerOrganizationIds } from '../../store/slice'
import { Label } from '../Label'
import { ChartContent } from './ChartContent'
import { SideBar } from './sidebar'
import { changeData, getTreeList, selectActiveItem } from './store/slice'
import { getFinancialAnalysis } from './store/thunk'
import { TableContent } from './tableContent'

export const FinancialAnalysis = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const activeItem = useSelector(selectActiveItem)
  const peerOrganizationIds = useSelector(selectPeerOrganizationIds)
  const treeList = useSelector(getTreeList)
  const locale = useSelector((state) => state.i18n.locale)
  const settingsFS = useGetSettingFinancialStatement()

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    if (activeItem) {
      const activeData = treeList
        .map((item) => item.children)
        .flat()
        .find((childItem) => childItem.itemId === activeItem)

      if (activeData) {
        dispatch(changeData({ data: activeData.data, unit: activeData.unit }))
      }
    }
  }, [activeItem])

  useEffect(() => {
    dispatch(
      getFinancialAnalysis({
        organizationId,
        peerOrganizationIds,
        ...settingsFS,
      }),
    )
  }, [locale, peerOrganizationIds])

  const renderBottomComponent = () => {
    return (
      <Element className="dFlex h100">
        <div className="flex1">
          <TableContent />
        </div>
        <div style={{ width: 350, marginLeft: 36 }}>
          <ChartContent />
        </div>
      </Element>
    )
  }

  return (
    <Panel
      height={512}
      renderLabel={() => (
        <Label
          label={'companyAnalysis.peerAnalysis.FINANCIAL_ANALYSIS'}
          renderToolTipContent={() => (
            <Translate value="companyAnalysis.peerAnalysis.FINANCIAL_ANALYSIS_TOOLTIP_DISCLAIMER" />
          )}
        />
      )}
    >
      <SideBar
        list={treeList}
        renderBottomComponent={renderBottomComponent}
        activeItem={activeItem}
      />
    </Panel>
  )
}
